import { render } from "./SelfMatchPlayer.vue?vue&type=template&id=f6527454&scoped=true"
import script from "./SelfMatchPlayer.vue?vue&type=script&lang=js"
export * from "./SelfMatchPlayer.vue?vue&type=script&lang=js"

import "./SelfMatchPlayer.vue?vue&type=style&index=0&id=f6527454&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6527454"]])

export default __exports__